import { useState } from "react";
import { ShieldAlert, ShieldOff } from "lucide-react";

type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
  className?: string;
};

export async function confirmAdultAccess(): Promise<boolean> {
  if (window.sessionStorage.getItem("ism-adult-confirmed") === "true") return true;
  if (!window.confirm("This section may contain 18+ content. Confirm that you are at least 18 years old to continue.")) return false;
  const response = await fetch("/api/members/content/adult-access", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ confirmed: true }),
  });
  if (response.ok) window.sessionStorage.setItem("ism-adult-confirmed", "true");
  return response.ok;
}

export function AdultContentToggle({ value, onChange, className = "" }: Props) {
  const [busy, setBusy] = useState(false);

  async function toggle() {
    if (value) {
      onChange(false);
      return;
    }
    setBusy(true);
    try {
      if (await confirmAdultAccess()) onChange(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={busy}
      aria-pressed={value}
      className={`${className} flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium border transition-colors ${
        value
          ? "bg-red-500/10 border-red-500/40 text-red-400"
          : "border-border text-muted-foreground hover:text-foreground"
      }`}
    >
      {value ? <ShieldOff className="w-3.5 h-3.5" /> : <ShieldAlert className="w-3.5 h-3.5" />}
      18+ {busy ? "Checking" : value ? "On" : "Off"}
    </button>
  );
}